import {Component, Input} from '@angular/core';
import {AttributoValore} from '../../../common/model/attributovalore.model';

@Component({
    selector: 'app-show-attributi',
    template: `
    <div *ngFor="let valoreAttributo of valoriAttributi">
      <app-show-text *ngIf="valoreAttributo.attributo.tipo.isText()"
                     [label]="valoreAttributo.attributo.nome"
                     [value]="valoreAttributo.valore"></app-show-text>

      <app-show-color *ngIf="valoreAttributo.attributo.tipo.isColor()"
                     [label]="valoreAttributo.attributo.nome"
                     [value]="valoreAttributo.valore"></app-show-color>
    </div>
  `,
    standalone: false
})
export class ShowAttributiComponent {

  @Input() valoriAttributi: AttributoValore[];

}
